<div class="popup-div w-full justify-center flex-col items-center gap-8">
    <div class="flex justify-between items-center pb-3">
        <div class="flex gap-4 items-center">
            <div class="yellow-bar"></div>
            <h1 class="sub-text text-center">CSV Download</h1>
        </div>
        <img src="../../../assets/Icons/close-icon.svg" class="close-icon" (click)="close()" style="cursor: pointer" />
    </div>
        <div class="w-full max-md:w-full">

            <div class="flex-column">
                <h2 class="sidebar-text">
                    <span class="error-validation-text" style="font-size: 22px !important">*</span>CSV Type
                </h2>
            </div>

            <button mat-button [matMenuTriggerFor]="menu" class="menu-btn" #menuBtn>
                {{ selected_csv_category?.label || "Select an option" }}
            </button>
            <mat-menu #menu="matMenu" class="myMenu">
                <button (click)="selectCSVType(data)" *ngFor="let data of csv_category" mat-menu-item
                    style="width: 100% !important" [style.width.px]="menuBtn.offsetWidth">
                    {{ data?.label }}
                </button>
            </mat-menu>
        </div>

    <button class="button-submit flex justify-center items-center" style="margin-top: 4rem !important;" (click)="submit()">
        <span *ngIf="!button_loader">Download CSV</span>
        <mat-spinner class="button-loader" *ngIf="button_loader" diameter="20"></mat-spinner>
    </button>
</div>